import React, { useState } from "react";
import "../../styles/desktop/plus.css";
import bot from "../../assets/img/robot-black.png";

const Plus = () => {
    let user = sessionStorage.getItem("user");
    user = user ? JSON.parse(user).name : "visitante";

    // Array de mensagens para exibição
    const messages = [
        `Olá, ${user}! \nMeu nome é CAC, sou seu assistente virtual personalizado!`,
        "Você deve estar em dúvida sobre o que eu faço, certo?",
        "O que você acha de eu te ajudar a controlar a iluminação do seu condomínio?",
        "E sobre gerenciar os seus dispositivos de segurança? \nEu sei, também fico preocupado quando os dispositivos \nficam offline e não recebo uma notificação em meu whatsapp.",
        "Também posso auxiliar os seus moradores via whatsapp, disponibilizando informações sobre o condomínio, obras, regras, entre outros.",
        "Todos poderão conversar comigo, basta me chamar no whatsapp!",
        "E aí, o que achou? Gostaria de ser um membro PLUS e ter acesso a essas funcionalidades e muitas outras?",
    ];

    // Estado para controlar o índice da mensagem atual
    const [messageIndex, setMessageIndex] = useState(0);

    // Função para alternar a mensagem ao clicar no botão
    const changeMessage = () => {
        setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    };

    return (
        <div className="containerPlus">
            <div className="botContainer">
                <div className="botCircle">
                    <img src={bot} alt="bot" className="bot" />
                </div>
            </div>
            <div className="modalMensagem">   
                <div className="mensagemChat">
                    <p>
                        {messages[messageIndex].split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </p>
                </div>
                {messageIndex < messages.length - 1 && (
                    <button onClick={changeMessage} className="changeMessageButton">
                        continuar
                    </button>
                )}


                {messageIndex === messages.length - 1 && (
                    <a href="mailto:chatbot.comando@gmail.com" className="plusButton">
                        Seja um membro PLUS
                    </a>
                )}
            </div>
        </div>
    );
};

export default Plus;
